module.exports = __webpack_public_path__ + "static/media/Vela - DKGrey_White.adab517b.jpg";